module.exports = __webpack_public_path__ + "491dcac9bf5c90593a03469be0ec201e.fbx";